/**
 * Vuex 테마 모듈
 */

import { getTheme, themeToCssVars } from '@/themes'

const state = {
  currentShowcase: null,
  currentTheme: null
}

const getters = {
  currentShowcase: state => state.currentShowcase,
  currentTheme: state => state.currentTheme
}

const mutations = {
  SET_SHOWCASE(state, showcaseName) {
    state.currentShowcase = showcaseName
    state.currentTheme = getTheme(showcaseName)
  }
}

const actions = {
  setTheme({ commit, state }, showcaseName) {
    if (state.currentShowcase === showcaseName) return

    commit('SET_SHOWCASE', showcaseName)

    const theme = getTheme(showcaseName)
    const cssVars = themeToCssVars(theme)

    const root = document.documentElement
    Object.entries(cssVars).forEach(([key, value]) => {
      root.style.setProperty(key, value)
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/theme.js